import React from 'react';
import MultiSelectDropdown from 'LearningManager/components/MultiSelectDropdown';
import {
	PRIORITY_OPTIONS,
	STATUS_OPTIONS,
	TYPE_OPTIONS,
	CATEGORY_OPTIONS
} from 'LearningManager/constants/UserDashboard.constants';
import styles from './TrainingSection.module.scss';

const TrainingSection: React.FC = () => {
	return (
		<div>
			<div className={styles.header}>
				<span className={styles.title}>Training</span>
				<div className={styles.filters}>
					<MultiSelectDropdown
						placeholder="All priorities"
						options={PRIORITY_OPTIONS}
						className={styles.filter}
					/>
					<MultiSelectDropdown
						placeholder="All statuses"
						options={STATUS_OPTIONS}
						className={styles.filter}
					/>
					<MultiSelectDropdown
						placeholder="All types"
						options={TYPE_OPTIONS}
						className={styles.filter}
					/>
					<MultiSelectDropdown
						placeholder="All categories"
						options={CATEGORY_OPTIONS}
						className={styles.filter}
					/>
				</div>
			</div>
		</div>
	);
};

export default TrainingSection;
